import { trackLsqEvents }
  from '@programs_landing/components/mba/tracking/trackLsq';

const formClass = 'form-flow';
const prepkitClass = 'prepkit-download';
const ctaClass = `${prepkitClass}__cta`;

const parentFormEl = document.querySelector(`.${formClass}__modes`);
const prepkitEls = document.querySelectorAll(`.${prepkitClass}__submission`);
const ctaLoggedInUser = document.querySelectorAll(`.${ctaClass}--can-download`);
const ctaLogOutUser = document.querySelectorAll(
  `.${ctaClass}--cannot-download`,
);
const waitlistModalId = 'waitlist-modal';
const activeWaitlistMode = document.querySelector(
  `#${waitlistModalId} .${formClass}__mode--active`,
);

// method to show the prepkit wherever required
function showPrepkit() {
  ctaLogOutUser.forEach(ele => ele.classList.add('hidden'));
  ctaLoggedInUser.forEach(ele => ele.classList.remove('hidden'));
}

function prepkitDownloadSuccessFlow() {
  showPrepkit();
  if (ctaLoggedInUser.length) {
    trackLsqEvents({
      activity_name: 'prepkit_downloaded',
      description: 'User downloaded NSET Prepkit',
      check_existence: false,
    });
    window.open(ctaLoggedInUser[0], '_blank');
  }
}

function initialize() {
  if (activeWaitlistMode && prepkitEls) {
    [...prepkitEls].forEach((prepkitEl) => {
      prepkitEl.addEventListener('click', () => {
        parentFormEl?.setAttribute('data-success-action', 'prepkit_download');
      });
    });
  } else {
    showPrepkit();
  }
}

export default { initialize, showPrepkit, prepkitDownloadSuccessFlow };
